import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  platformSelected: new analytics.Event({
    name: 'Platform selected',
    description: 'Merchant selects integration platform',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['platform'],
    userAttributes: ['platform'],
  }),
  selectedOtherPlatformOption: new analytics.Event({
    name: 'Other Platform Option Selected',
    description: 'Merchant selects other platform option',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
  searchedForPlatform: new analytics.Event({
    name: 'Searching For Other Platform',
    description: 'Merchant searchs for platform',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['platformSearched'],
  }),
};
